import { useCallback } from "react"

import { useNavigate, useParams } from "react-router-dom"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useNavigateWithSearchParams, useUrlParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { EquipmentSidebarComponents } from "../../component/EquipmentSidebarComponents"
import { EQUIPMENT_CONDITION_URL_PARAM, EQUIPMENT_CODE_URL_PARAM } from "../../constants/urlParams"
import { useEquipmentStateContext } from "../../contexts/EquipmentContext"
import { useGetEquipmentTypeCatalogUtils } from "../../hooks/utils/useGetEquipmentTypeCatalogUtils"

import * as Styled from "./EquipmentMobileContent.styled"

export const EquipmentMobileContent = () => {
    const { getEquipmentTypeDepth, getEquipmentTypeChildren } = useGetEquipmentTypeCatalogUtils()
    const navigateWithSearchParams = useNavigateWithSearchParams()
    const navigate = useNavigate()

    const { getParam, getParams } = useUrlParams()
    const searchParams = getParams()
    const { ascendantCodes, filters } = useEquipmentStateContext()
    const { t } = useTranslation(I18N_NAMESPACE)
    const { code, road } = useParams()

    const handleChangeFilter = useCallback((filters) => {
        const filterCodeDepth = getEquipmentTypeDepth(filters.type)
        const children = getEquipmentTypeChildren(filters.type)
        if (filterCodeDepth % 2 === 1 && children.length > 1) {
            const condition = getParam(EQUIPMENT_CONDITION_URL_PARAM)
            navigateWithSearchParams(`./code/${filters.type}?${EQUIPMENT_CODE_URL_PARAM}=${filters.type}${condition ? `&${EQUIPMENT_CONDITION_URL_PARAM}=${condition}` : ""}`)
        }
    }, [getParam, getEquipmentTypeDepth, getEquipmentTypeChildren, navigateWithSearchParams])

    const navigateBack = useCallback(() => {
        const filterCodeDepth = getEquipmentTypeDepth(filters.type)

        if (code && filterCodeDepth % 2 === 0) {
            searchParams.set(EQUIPMENT_CODE_URL_PARAM, ascendantCodes[1])
            const newParams = Array.from(searchParams.entries()).reduce((acc, [key, value]) => {
                return `${acc}${key}=${value}&`
            }, "?")
                .slice(0, -1)
            navigate(road ? `../${road}${newParams}` : `../${newParams}`)
        } else {
            navigateWithSearchParams("../")
        }
    }, [ascendantCodes, code, getEquipmentTypeDepth, navigate, navigateWithSearchParams, searchParams, road, filters.type])

    return (
        <Styled.BottomSheetContent
            id="equipment-sidebar"
            onBack={(road || code) ? navigateBack : null}
            title={t(I18N_NAMESPACE, `containers.equipmentSidebar.${road ? "roadTitle" : "title"}`)}
        >
            <Styled.Container>
                <EquipmentSidebarComponents handleChangeTypeFilter={handleChangeFilter} />
            </Styled.Container>
        </Styled.BottomSheetContent>
    )
}